import PropTypes from 'prop-types';
import React from 'react';

import FirebaseAuthContext from './firebase-auth-context';

const FirebaseAuthConsumer = ({ children }) => (
  <FirebaseAuthContext.Consumer>
    {state => children(state)}
  </FirebaseAuthContext.Consumer>
);

FirebaseAuthConsumer.propTypes = {
  children: PropTypes.func.isRequired,
};

FirebaseAuthConsumer.displayName = 'FirebaseAuthConsumer';

export default FirebaseAuthConsumer;
